import { useState, useEffect, useRef } from 'react';
import './App.css';
import photo1 from './photos/photo_1.jpeg';
import photo2 from './photos/photo_2.jpg';
import photo3 from './photos/photo_3.jpg';
import photo4 from './photos/photo_4.png';
import photo5 from './photos/photo_5.jpeg';
import photo6 from './photos/photo_6.jpeg';
import photo7 from './photos/photo_7.jpeg';
import photo8 from './photos/photo_8.jpeg';
import photo11 from './photos/photo_11.jpeg';
import photo12 from './photos/photo_12.jpeg';
import photo13 from './photos/photo_13.jpeg';
import photo15 from './photos/photo_15.jpeg';
import photo16 from './photos/photo_16.jpeg';

const BotanicalLeft = () => (
  <svg viewBox="0 0 300 400" className="fixed left-0 bottom-0 w-72 h-96 opacity-80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M80 380 Q40 280 90 200 Q140 120 80 40" stroke="#5c6b84" strokeWidth="2" fill="none" opacity="0.5"/>
    <path d="M100 380 Q60 300 110 220 Q160 140 95 60" stroke="#5c6b84" strokeWidth="1.5" fill="none" opacity="0.4"/>
    <path d="M60 380 Q20 290 75 210 Q130 130 65 50" stroke="#5c6b84" strokeWidth="1" fill="none" opacity="0.3"/>
    <ellipse cx="70" cy="50" rx="30" ry="50" fill="#b87d6e" opacity="0.25" transform="rotate(-25 70 50)"/>
    <ellipse cx="100" cy="100" rx="25" ry="40" fill="#5c6b84" opacity="0.2" transform="rotate(20 100 100)"/>
    <ellipse cx="50" cy="150" rx="28" ry="45" fill="#b87d6e" opacity="0.2" transform="rotate(-15 50 150)"/>
    <ellipse cx="110" cy="180" rx="22" ry="35" fill="#5c6b84" opacity="0.15" transform="rotate(10 110 180)"/>
    <circle cx="75" cy="80" r="12" fill="#5c6b84" opacity="0.3"/>
    <circle cx="55" cy="130" r="8" fill="#b87d6e" opacity="0.35"/>
    <circle cx="90" cy="170" r="10" fill="#5c6b84" opacity="0.25"/>
    <circle cx="65" cy="220" r="7" fill="#b87d6e" opacity="0.3"/>
  </svg>
);

const BotanicalRight = () => (
  <svg viewBox="0 0 300 400" className="fixed right-0 bottom-0 w-72 h-96 opacity-80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M220 380 Q260 280 210 200 Q160 120 220 40" stroke="#5c6b84" strokeWidth="2" fill="none" opacity="0.5"/>
    <path d="M200 380 Q240 300 190 220 Q140 140 205 60" stroke="#5c6b84" strokeWidth="1.5" fill="none" opacity="0.4"/>
    <path d="M240 380 Q280 290 225 210 Q170 130 235 50" stroke="#5c6b84" strokeWidth="1" fill="none" opacity="0.3"/>
    <ellipse cx="230" cy="50" rx="30" ry="50" fill="#b87d6e" opacity="0.25" transform="rotate(25 230 50)"/>
    <ellipse cx="200" cy="100" rx="25" ry="40" fill="#5c6b84" opacity="0.2" transform="rotate(-20 200 100)"/>
    <ellipse cx="250" cy="150" rx="28" ry="45" fill="#b87d6e" opacity="0.2" transform="rotate(15 250 150)"/>
    <ellipse cx="190" cy="180" rx="22" ry="35" fill="#5c6b84" opacity="0.15" transform="rotate(-10 190 180)"/>
    <circle cx="225" cy="80" r="12" fill="#5c6b84" opacity="0.3"/>
    <circle cx="245" cy="130" r="8" fill="#b87d6e" opacity="0.35"/>
    <circle cx="210" cy="170" r="10" fill="#5c6b84" opacity="0.25"/>
    <circle cx="235" cy="220" r="7" fill="#b87d6e" opacity="0.3"/>
  </svg>
);

const HOTELS = [
  { num: 1, lat: 20.665757, lng: -103.393734, name: 'Hotel Riu Plaza Guadalajara' },
  { num: 2, lat: 20.664231, lng: -103.394893, name: 'Hotel Victoria Ejecutivo Guadalajara' },
  { num: 3, lat: 20.661204, lng: -103.396558, name: 'Hotel Indigo Guadalajara Expo' },
  { num: 4, lat: 20.665333, lng: -103.395606, name: 'Baruk Hotel de Autor Guadalajara' },
  { num: 5, lat: 20.650118, lng: -103.404248, name: 'InterContinental Presidente Guadalajara' },
  { num: 6, lat: 20.644850, lng: -103.408138, name: 'Wyndham Garden Guadalajara Expo' },
  { num: 7, lat: 20.671361, lng: -103.417128, name: 'Candlewood Suites Guadalajara Galerias' },
];

const VENUE = { lat: 20.6651499, lng: -103.4070435, name: 'ROOF 128' };

const LocationMap = () => {
  const mapDivRef = useRef(null);
  const mapRef = useRef(null);
  const markersRef = useRef({});

  useEffect(() => {
    if (!window.L || !mapDivRef.current) return;

    const map = window.L.map(mapDivRef.current, {
      center: [20.659, -103.403],
      zoom: 13,
      zoomControl: true,
      scrollWheelZoom: false,
    });
    mapRef.current = map;

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
    }).addTo(map);

    const venueIcon = window.L.divIcon({
      className: 'venue-marker-wrap',
      html: '<div style="background-color: #b87d6e; color: white; width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18px; font-family: \'Libre Baskerville\', serif; box-shadow: 0 3px 8px rgba(0,0,0,0.4); border: 2px solid #fbfafa;">★</div>',
      iconSize: [36, 36],
      iconAnchor: [18, 18],
    });
    window.L.marker([VENUE.lat, VENUE.lng], { icon: venueIcon, title: VENUE.name }).addTo(map);

    HOTELS.forEach((hotel) => {
      const icon = window.L.divIcon({
        className: 'hotel-marker-wrap',
        html: `<div style="background-color: #5c6b84; color: white; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 700; font-family: 'Libre Baskerville', serif; box-shadow: 0 2px 6px rgba(0,0,0,0.3); border: 2px solid #fbfafa;">${hotel.num}</div>`,
        iconSize: [32, 32],
        iconAnchor: [16, 16],
      });
      const marker = window.L.marker([hotel.lat, hotel.lng], { icon, title: hotel.name }).addTo(map);
      markersRef.current[hotel.num] = marker;
    });

    return () => map.remove();
  }, []);

  const focusHotel = (num) => {
    const hotel = HOTELS.find((h) => h.num === num);
    const marker = markersRef.current[num];
    if (!hotel || !mapRef.current) return;

    mapRef.current.flyTo([hotel.lat, hotel.lng], 16, { duration: 0.8 });

    if (marker) {
      const el = marker.getElement();
      if (el) {
        el.classList.remove('pulse');
        void el.offsetWidth;
        el.classList.add('pulse');
        setTimeout(() => el.classList.remove('pulse'), 1000);
      }
    }
  };

  return (
    <>
      <div className="rounded-lg overflow-hidden border border-border">
        <div ref={mapDivRef} className="map-container" style={{ height: '288px', width: '100%' }} />
      </div>
      <ol className="mt-6 space-y-1 max-w-md mx-auto text-left">
        {HOTELS.map((hotel) => (
          <li key={hotel.num}>
            <button
              type="button"
              onClick={() => focusHotel(hotel.num)}
              className="w-full flex items-center justify-start gap-3 px-3 py-2 rounded hover:bg-sage/5 transition-colors group text-left"
            >
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-slate text-white text-xs font-bold flex items-center justify-center font-body group-hover:bg-terracotta transition-colors">
                {hotel.num}
              </span>
              <span className="font-body text-sm text-sage text-left group-hover:text-terracotta transition-colors">
                {hotel.name}
              </span>
            </button>
          </li>
        ))}
      </ol>
    </>
  );
};

const WEDDING_START_UTC = '20261121T230000Z';
const WEDDING_END_UTC = '20261122T050000Z';

const handleAddToCalendar = () => {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: 'Boda Areli & Juan Carlos',
    dates: `${WEDDING_START_UTC}/${WEDDING_END_UTC}`,
    location: 'ROOF 128, Av. Guadalupe 1601, Chapalita, Zapopan, Jal.',
  });
  window.open(`https://calendar.google.com/calendar/render?${params.toString()}`, '_blank', 'noopener,noreferrer');
};

const Monogram = () => (
  <svg viewBox="0 0 140 60" className="w-24 h-14 mx-auto mb-6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <text x="70" y="48" textAnchor="middle" fontFamily="Playfair Display, serif" fontSize="52" fontWeight="300" fill="#b87d6e" letterSpacing="0.08em">A & J</text>
  </svg>
);

const InstaxFrame = ({ photo }) => (
  <div className="bg-white p-3 shadow-lg rotate-1 hover:rotate-0 transition-transform duration-300">
    <div className="bg-gray-100 overflow-hidden aspect-[3/4]">
      <img src={photo} alt="" className="w-full h-full object-cover" />
    </div>
  </div>
);



const PhotoCarousel = ({ photos }) => {
  const [current, setCurrent] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchDiff, setTouchDiff] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [squeezeKey, setSqueezeKey] = useState(0);

  const goTo = (index) => {
    if (animating || index === current || index < 0 || index >= photos.length) return;
    setAnimating(true);
    setCurrent(index);
    setSqueezeKey((k) => k + 1);
    setTimeout(() => setAnimating(false), 500);
  };

  const next = () => goTo(current + 1);
  const prev = () => goTo(current - 1);

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
    setTouchDiff(0);
  };

  const handleTouchMove = (e) => {
    if (touchStart === null) return;
    setTouchDiff(e.touches[0].clientX - touchStart);
  };

  const handleTouchEnd = () => {
    if (Math.abs(touchDiff) > 50) {
      if (touchDiff > 0) prev();
      else next();
    }
    setTouchStart(null);
    setTouchDiff(0);
  };

  return (
    <div className="relative max-w-md mx-auto select-none">
      <div
        className="overflow-hidden touch-pan-y cursor-grab active:cursor-grabbing"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="flex transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
          style={{
            transform: touchStart !== null
              ? `translateX(calc(${-current * 100}% + ${touchDiff}px))`
              : `translateX(-${current * 100}%)`,
          }}
        >
          {photos.map((photo, index) => (
            <div
              key={index}
              className={`w-full flex-shrink-0 flex justify-center px-4 ${index === current && squeezeKey > 0 ? 'photo-squeeze' : ''}`}
            >
              <InstaxFrame photo={photo.src} />
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-center gap-6 mt-6">
        <button
          onClick={prev}
          disabled={current === 0}
          className="w-10 h-10 rounded-full border border-sage/20 flex items-center justify-center text-sage/50 hover:border-terracotta hover:text-terracotta transition-colors disabled:opacity-20 disabled:cursor-default"
          aria-label="Anterior"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-current stroke-2"><path d="M15 18l-6-6 6-6"/></svg>
        </button>

        <div className="flex gap-2">
          {photos.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`rounded-full transition-all duration-500 ${
                i === current ? 'bg-terracotta w-4 h-2' : 'bg-sage/20 hover:bg-sage/40 w-2 h-2'
              }`}
              aria-label={`Foto ${i + 1}`}
            />
          ))}
        </div>

        <button
          onClick={next}
          disabled={current === photos.length - 1}
          className="w-10 h-10 rounded-full border border-sage/20 flex items-center justify-center text-sage/50 hover:border-terracotta hover:text-terracotta transition-colors disabled:opacity-20 disabled:cursor-default"
          aria-label="Siguiente"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-current stroke-2"><path d="M9 18l6-6-6-6"/></svg>
        </button>
      </div>
    </div>
  );
};

const RSVPModal = ({ isOpen, onClose }) => {
  const [phone, setPhone] = useState('');
  const [step, setStep] = useState('phone');
  const [guests, setGuests] = useState([]);
  const [guestStatuses, setGuestStatuses] = useState({});
  const [guestNames, setGuestNames] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const API_BASE = 'https://rr9smrmu78.execute-api.us-east-1.amazonaws.com/production';

  const normalizePhone = (value) => value.replace(/\D/g, '');

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleSearch = async () => {
    if (!phone.trim()) {
      setError('Por favor ingresa tu número de teléfono');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const normalized = normalizePhone(phone);
      const response = await fetch(`${API_BASE}/search?phone=${normalized}`);
      const data = await response.json();

      if (!data.guests || data.guests.length === 0) {
        setError('No encontramos invitados con ese número de teléfono');
        setLoading(false);
        return;
      }

      setGuests(data.guests);
      const initialStatuses = {};
      const initialNames = {};
      data.guests.forEach((guest) => {
        initialStatuses[guest.id] = guest.status || 'Sin respuesta';
        initialNames[guest.id] = guest.name || '';
      });
      setGuestStatuses(initialStatuses);
      setGuestNames(initialNames);
      setStep('confirm');
    } catch (err) {
      setError('Error al buscar. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (guestId, status) => {
    setGuestStatuses((prev) => ({
      ...prev,
      [guestId]: status,
    }));
  };

  const handleNameChange = (guestId, name) => {
    setGuestNames((prev) => ({
      ...prev,
      [guestId]: name,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    try {
      const guestsPayload = guests.map((guest) => ({
        id: guest.id,
        party: guest.party,
        name: guestNames[guest.id]?.trim() || 'Sin nombre',
        status: guestStatuses[guest.id],
      }));

      await fetch(`${API_BASE}/rsvp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ guests: guestsPayload }),
      });

      setStep('success');
    } catch (err) {
      setError('Error al enviar. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setPhone('');
    setStep('phone');
    setGuests([]);
    setGuestStatuses({});
    setGuestNames({});
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-cream rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-sage/60 hover:text-sage"
        >
          <svg viewBox="0 0 24 24" className="w-6 h-6 fill-none stroke-current stroke-2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>

        {step === 'phone' && (
          <>
            <h3 className="font-display text-2xl text-sage mb-4 text-center">Confirmar Asistencia</h3>
            <p className="font-body text-sm text-sage/80 mb-6 text-center">
              Ingresa el número de teléfono de cualquier invitado de tu grupo.
            </p>
            <input
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              placeholder="Teléfono a 10 dígitos"
              className="w-full border border-sage/30 rounded px-4 py-3 font-body text-sage mb-2 text-center text-lg tracking-wider"
            />
            <p className="font-body text-sm text-sage/60 text-center mb-4">
              Confirma tu asistencia antes del 1 de octubre.
            </p>
            {error && <p className="text-red-500 text-sm mb-4 text-center">{error}</p>}
            <button
              onClick={handleSearch}
              disabled={loading}
              className="w-full bg-terracotta text-cream font-body text-xs uppercase tracking-[0.15em] px-10 py-3 hover:bg-terracotta/90 transition-colors disabled:opacity-50"
            >
              {loading ? 'Buscando...' : 'Buscar mi invitación'}
            </button>
          </>
        )}

        {step === 'confirm' && (
          <>
            <h3 className="font-display text-2xl text-sage mb-2 text-center">Confirmar Asistencia</h3>
            <p className="font-body text-xs text-sage/60 mb-6 text-center">
              Teléfono: {phone}
              <button
                onClick={() => setStep('phone')}
                className="ml-2 text-terracotta underline hover:text-terracotta/80"
              >
                Cambiar
              </button>
            </p>
            <div className="space-y-4 mb-6">
              {guests.map((guest) => {
                const canEditName = guest.editableName === true;
                return (
                  <div key={guest.id} className="flex items-center gap-3 border-b border-border pb-3">
                    <input
                      type="text"
                      value={guestNames[guest.id] ?? ''}
                      onChange={(e) => handleNameChange(guest.id, e.target.value)}
                      placeholder={guest.name || 'Sin nombre'}
                      disabled={!canEditName}
                      className="flex-1 border border-sage/30 rounded px-3 py-1 font-display text-sage bg-cream focus:outline-none focus:border-sage disabled:opacity-60 disabled:cursor-not-allowed disabled:bg-sage/5"
                    />
                    <select
                      value={guestStatuses[guest.id]}
                      onChange={(e) => handleStatusChange(guest.id, e.target.value)}
                      className="border border-sage/30 rounded px-3 py-1 font-body text-sm text-sage bg-cream"
                    >
                      <option value="Sin respuesta">Sin respuesta</option>
                      <option value="Confirmo">Confirmo</option>
                      <option value="No ire">No ire</option>
                    </select>
                  </div>
                );
              })}
            </div>
            {error && <p className="text-red-500 text-sm mb-4 text-center">{error}</p>}
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="w-full bg-terracotta text-cream font-body text-xs uppercase tracking-[0.15em] px-10 py-3 hover:bg-terracotta/90 transition-colors disabled:opacity-50"
            >
              {loading ? 'Enviando...' : 'Guardar'}
            </button>
          </>
        )}

        {step === 'success' && (
          <>
            <div className="text-center">
              <svg viewBox="0 0 24 24" className="w-16 h-16 mx-auto mb-4 fill-none stroke-terracotta stroke-2">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              <h3 className="font-display text-2xl text-sage mb-4">¡Listo!</h3>
              <p className="font-body text-sage/80 mb-6">
                Tu respuesta ha sido guardada.
              </p>
              <button
                onClick={handleClose}
                className="inline-block border border-terracotta text-terracotta font-body text-xs uppercase tracking-[0.15em] px-10 py-3 hover:bg-terracotta hover:text-cream transition-colors"
              >
                Cerrar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

function App() {
  const [rsvpOpen, setRsvpOpen] = useState(false);
  const [clabeCopied, setClabeCopied] = useState(false);

  const CLABE = '0026 5070 0978 0353 47';
  const CLABE_RAW = '002650700978035347';

  const handleCopyClabe = async () => {
    try {
      await navigator.clipboard.writeText(CLABE_RAW);
      setClabeCopied(true);
      setTimeout(() => setClabeCopied(false), 2000);
    } catch (err) {
      const input = document.createElement('input');
      input.value = CLABE_RAW;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setClabeCopied(true);
      setTimeout(() => setClabeCopied(false), 2000);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.reveal');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const photos = [
    { src: photo13 },
    { src: photo12 },
    { src: photo16 },
    { src: photo15 },
    { src: photo11 },
    { src: photo8 },
    { src: photo6 },
    { src: photo7 },
    { src: photo5 },
    { src: photo4 },
    { src: photo3 },
    { src: photo2 },
    { src: photo1 },
  ];

  return (
    <div className="min-h-screen bg-cream relative overflow-x-clip">
      <BotanicalLeft />
      <BotanicalRight />

      <header className="fixed top-0 left-0 right-0 z-50 flex justify-center py-2 bg-cream">
        <Monogram />
      </header>

      <main className="relative z-10 max-w-2xl mx-auto px-6 pt-24 pb-16">
        <section className="min-h-screen flex flex-col justify-center items-center text-center reveal">
          <h1 className="font-display text-4xl md:text-7xl font-normal tracking-wide text-sage mb-4 whitespace-nowrap">
            Areli &amp;<br />Juan Carlos
          </h1>
          <p className="font-display text-lg md:text-xl font-light tracking-[0.15em] text-sage/80 mb-6">21 &middot; 11 &middot; 26</p>
          <div className="mt-16 w-px h-16 bg-border"></div>
        </section>

        <section className="py-16 reveal">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0 text-center md:text-left">
            <div className="md:border-r md:border-border md:pr-8">
              <p className="font-body text-xs uppercase tracking-[0.15em] text-sage/60 mb-2">Día</p>
              <p className="font-display text-3xl font-normal text-sage">21 DE NOVIEMBRE</p>
              <p className="font-body text-sm text-sage/80 mt-1">2026</p>
              <button
                type="button"
                onClick={handleAddToCalendar}
                className="inline-block mt-3 text-center md:text-left font-body text-xs uppercase tracking-[0.1em] leading-relaxed text-slate underline underline-offset-4 hover:text-terracotta transition-colors"
              >
                Agregar a mi
                <br />
                calendario
              </button>
            </div>

            <div className="md:border-r md:border-border md:px-8">
              <p className="font-body text-xs uppercase tracking-[0.15em] text-sage/60 mb-2">Lugar</p>
              <p className="font-display text-3xl font-normal text-sage leading-relaxed">ROOF 128</p>
              <p className="font-display text-base font-normal text-sage/80 leading-relaxed">Av. Guadalupe 1601, Chapalita</p>
              <p className="font-display text-base font-normal text-sage/80">Zapopan, Jal.</p>
              <a
                href="https://maps.app.goo.gl/kh6fs9tvdQoa5fiPA"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 text-center md:text-left font-body text-xs uppercase tracking-[0.1em] leading-relaxed text-slate underline underline-offset-4 hover:text-terracotta transition-colors"
              >
                Ver en Google Maps
              </a>
              <div className="mt-4 mx-auto md:mx-0 border border-border rounded px-4 py-3 max-w-xs text-center md:text-left font-body text-xs text-sage/80 leading-relaxed">
                <p>Terraza semiabierta</p>
                <p>Valet · Elevador</p>
                <p>Clima 26° – 13°</p>
              </div>
            </div>

            <div className="md:pl-8">
              <p className="font-body text-xs uppercase tracking-[0.15em] text-sage/60 mb-2">Hora</p>
              <p className="font-display text-3xl font-normal text-sage">5:00 P.M.</p>
            </div>
          </div>
        </section>

        <section className="py-12 text-center reveal">
          <div className="w-px h-12 bg-border mx-auto mb-8"></div>
          <p className="font-display text-lg font-normal text-sage max-w-md mx-auto leading-relaxed italic">
            Gracias por ser parte de nuestra historia. Con mucho cariño te invitamos a compartir este momento con nosotros.
          </p>
        </section>

        <section className="py-12 relative reveal">
          <h2 className="font-display text-3xl font-normal text-sage text-center mb-8 relative z-10">Nuestro viaje</h2>
          <div className="relative z-10">
            <PhotoCarousel photos={photos} />
          </div>
        </section>

        <section className="py-12 text-center reveal">
          <h2 className="font-display text-3xl font-normal text-sage mb-6">Código de Vestimenta</h2>
          <p className="font-display text-xl font-normal text-sage/80 italic">Cocktail / Semi-formal / Formal</p>
        </section>

        <section className="py-12 text-center reveal">
          <h2 className="font-display text-3xl font-normal text-sage mb-6">Agenda</h2>
          <div className="space-y-4 max-w-md mx-auto">
            <div className="border-b border-border pb-3">
              <p className="font-body text-xs uppercase tracking-[0.15em] text-sage/60 mb-1">Recepción</p>
              <p className="font-display text-lg font-normal text-sage">5:00 p.m.</p>
            </div>
            <div className="border-b border-border pb-3">
              <p className="font-body text-xs uppercase tracking-[0.15em] text-sage/60 mb-1">Ceremonia</p>
              <p className="font-display text-lg font-normal text-sage">5:30 p.m.</p>
            </div>
            <div>
              <p className="font-body text-xs uppercase tracking-[0.15em] text-sage/60 mb-1">Cena y Baile</p>
              <p className="font-display text-lg font-normal text-sage">7:30 p.m. - 11:00 p.m.</p>
            </div>
          </div>
        </section>

        <section className="py-12 text-center reveal">
          <h2 className="font-display text-3xl font-normal text-sage mb-6">Hoteles cercanos</h2>
          <LocationMap />
        </section>

        <section className="py-12 text-center reveal">
          <h2 className="font-display text-3xl font-normal text-sage mb-6">Regalos</h2>
          <p className="font-display text-lg font-normal text-sage/80 italic max-w-md mx-auto">
            Tu presencia es el mejor regalo.
          </p>
          <p className="font-body text-sm text-sage/60 mt-4 max-w-md mx-auto">
            Si deseas obsequiarnos algo, tendremos sobres disponibles en la mesa de regalos durante el evento.
          </p>
          <p className="font-body text-sm text-sage/60 mt-8 max-w-md mx-auto">
            O si prefieres, transferencia bancaria de <span className="font-semibold">Banamex</span> a nombre de <span className="font-semibold">Areli Maria Ch Duran</span>
          </p>
          <button
            type="button"
            onClick={handleCopyClabe}
            className="inline-flex items-center gap-2 sm:gap-3 border border-sage/30 hover:border-terracotta rounded px-3 sm:px-5 py-2.5 sm:py-3 transition-colors group"
            aria-label="Copiar CLABE"
          >
            <span className="font-mono text-sage text-xs sm:text-sm tracking-[0.05em] sm:tracking-[0.15em] whitespace-nowrap">
              {CLABE}
            </span>
            <span className="font-body text-[10px] sm:text-xs uppercase tracking-[0.1em] sm:tracking-[0.15em] text-sage/60 group-hover:text-terracotta transition-colors whitespace-nowrap">
              {clabeCopied ? '¡Copiado!' : 'Copiar CLABE'}
            </span>
          </button>
          <p className="font-body text-sm text-sage/60 mt-4 max-w-md mx-auto">
            Por favor, indica <span className="font-semibold">Regalo de Boda</span> como concepto en tu transferencia.
          </p>
        </section>

        <section className="py-12 text-center reveal">
          <h2 className="font-display text-3xl font-normal text-sage mb-6">RSVP</h2>
          <p className="font-display text-lg font-normal text-sage/80 italic max-w-md mx-auto leading-relaxed mb-8">
            Queremos compartir contigo la felicidad de nuestra unión.
          </p>
          <p className="font-body text-sm text-sage/60 mb-4">* Solo adultos.</p>
          <button
            type="button"
            onClick={() => setRsvpOpen(true)}
            className="inline-block border border-terracotta text-terracotta font-body text-xs uppercase tracking-[0.15em] px-10 py-3 hover:bg-terracotta hover:text-cream transition-colors"
          >
            Confirmar asistencia
          </button>
        </section>

        <section className="py-16 text-center reveal">
          <h3 className="font-display text-3xl md:text-4xl font-normal text-sage mb-6">
            Gracias
          </h3>
          <p className="font-body text-sm md:text-base text-sage/80 max-w-md mx-auto leading-relaxed mb-10">
            Ya sea de cerca o a la distancia, nos llena de alegría compartir este momento contigo.
          </p>
          <p className="font-display text-lg text-sage/80 italic mb-12">
            Con amor,
            <br />
            Areli &amp; Juan Carlos
          </p>
          <div className="flex items-center justify-center gap-4" aria-hidden="true">
            <div className="h-px w-16 bg-border"></div>
            <svg viewBox="0 0 60 20" className="w-12 h-4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 10 Q 30 4 55 10" stroke="#5c6b84" strokeWidth="0.8" fill="none" opacity="0.6" />
              <ellipse cx="20" cy="7" rx="2.5" ry="4" fill="#b87d6e" opacity="0.5" transform="rotate(-30 20 7)" />
              <ellipse cx="40" cy="7" rx="2.5" ry="4" fill="#5c6b84" opacity="0.5" transform="rotate(30 40 7)" />
              <circle cx="30" cy="10" r="1.2" fill="#b87d6e" opacity="0.6" />
            </svg>
            <div className="h-px w-16 bg-border"></div>
          </div>
        </section>

      </main>

      <RSVPModal isOpen={rsvpOpen} onClose={() => setRsvpOpen(false)} />
    </div>
  );
}

export default App;
